import Cookies from 'js-cookie';
import { CURRENCY_INR, CURRENCY_USD, SWITCH_CURRENCY } from '@/common/constants';
import { getQueryByLocationSearch } from '@/utils/index';

export const CURRENCY_COOKIE_KEY = '_zm_currency';

export const getCurrency = () => {
    if (isCurrencySwitch()) {
        const query = getQueryByLocationSearch();
        return query.currency || Cookies.get(CURRENCY_COOKIE_KEY) || 'USD';
    }
    
    const currency = Cookies.get(CURRENCY_COOKIE_KEY);
    return currency || 'USD';
};

export const isInrCurrency = () => {
  return getCurrency() === CURRENCY_INR;
};

export const isTargetCurrencyInr = () => {
  return getEffectiveCurrency() === CURRENCY_INR;
};

export const isCurrencySwitchTargetInr = () => {
  if (!isCurrencySwitch()) {
    return false;
  }
  const queryParams = getQueryByLocationSearch();
  return queryParams.currency === CURRENCY_INR;
};

export const isUSCurrency = () => {
  return getCurrency() === CURRENCY_USD;
}

export const isCurrency = (targetCurrency) => {
  return getCurrency() === targetCurrency
}

export const setCurrency = currency => {
  let domain = document.body.getAttribute('data-cd') || '.zoom.us';
  Cookies.remove(CURRENCY_COOKIE_KEY);
  Cookies.set(CURRENCY_COOKIE_KEY, currency, { expires: 1, path: '/', domain, secure: true });
  window.location.reload();
};

/**
 *
 * @param {String: USD | AUD | EUR | GBP | JPY | CAD | CNY} currency
 *
 */
export const getCurrencySymbol = currency => {
  switch (currency) {
    case 'USD':
      return '$';
    case 'AUD':
      return 'A$';
    case 'EUR':
      return '\u20AC';
    case 'GBP':
      return '\u00A3';
    case 'JPY':
      return '\uFFE5';
    case 'CAD':
      return 'CAD';
    case 'CNY':
      return '\uFFE5';
    case 'INR':
      return '₹';
    case 'NZD':
      return 'NZ$';
    case 'SAR':
      return 'SAR';
    case 'ZAR':
      return 'R';
    case 'AED':
      return 'AED';
    default:
      return window.SB?.getCurrencySymbol(currency) ?? currency;
  }
};

export const isCurrencySwitch = () => {
  const query = getQueryByLocationSearch()
  const operation = query.operation || ''
  return operation === SWITCH_CURRENCY;
};

// with currency switch
export const getEffectiveCurrency = () => {
  if (isCurrencySwitch()) {
    const query = getQueryByLocationSearch();
    return query.currency || getCurrency();
  }

  return getCurrency();
};

export const getSetupIntentCurrency = () => {
  const currency = getEffectiveCurrency();
  if (currency === 'INR') {
    return currency;
  }
  const { doSetupIntentInUsd } = window.exportControlConfig || {};
  return doSetupIntentInUsd ? 'USD' : currency;
};
